// @ts-nocheck
import React, { useEffect, useState } from "react";
import Reactportal from "../../Reactportal/Reactportal";
import { replaceUnderscore } from "../../../../CommonFunction/common";
import PortalFooter from "../../Reactportal/PortalFooter";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import { DeliveryDataConfig, Deliverydocs } from "./AddBookingBrokerConfig";
import "./MarkDelivery.scss";
import DocumentuploadSection from "../../../Templets/DocumentuploadSection/DocumentuploadSection";
import { updateValueForm } from "../../FormInputSectionComponent/formUtils";

const MarkDelivery = ({
  show,
  Form_Key,
  formRef,
  handleErrorsChange,
  HanldeChangeonForm,
  handleClose,
  TypeOfPortal,
  FormData,
  handleSubmit,
}) => {
  const [toggle, setToggle] = useState(show ? show : false);
  let submit = () => {
    handleSubmit();
    setToggle(!toggle);
    handleClose();
  };

  // console.log(formRef.current, FormData);
  useEffect(() => {
    updateValueForm(formRef, FormData);
  }, []);
  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={false}
      submitform={submit}
      submitType={""}
      SaveAndClose={submit}
      handleformclose={() => {
        setToggle(!toggle);
        handleClose();
      }}
      loadingState={false}
    />
  );

  return (
    <>
      <div>
        <Reactportal
          FoooterContent={footerContent}
          open={toggle}
          onClose={() => {
            setToggle(!toggle);
            handleClose();
          }}
          TypeOfPortal={"Mark Delivery"}
        >
          <div className="DeliveryMaindiv">
            <div className="horizontalcontainer">
              {DeliveryDataConfig &&
                DeliveryDataConfig.map((e) => {
                  return (
                    <div key={e.id} className="">
                      <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                      <div className="horizantalSection insidecontainer">
                        <FormInputSectionComponent
                          inputfields={e.fields}
                          Type={e.name}
                          onhandleFormikChange={HanldeChangeonForm}
                          // validation_Schema={e?.Valid_schema}
                          onErrorsChange={(newErrors) => handleErrorsChange(newErrors)}
                          formkey={Form_Key}
                          formRef={formRef}
                        />
                      </div>
                    </div>
                  );
                })}
              <div className="MarkDeliveryDoc">
                <DocumentuploadSection
                  data={Deliverydocs}
                  TypeOfPortal={TypeOfPortal}
                  LoadForm={true}
                  formkey={Form_Key}
                  values={FormData}
                  formReference={formRef}
                />
              </div>
            </div>

            {/* <div className="BookingFooterMaindiv">
              <div>
                <div>
                  <p className="BookingFooterLabel">Documents</p>
                </div>
                <div className="loadImages1">
                  <DocumentuploadSection
                    data={docs}
                    TypeOfPortal={TypeOfPortal}
                    LoadForm={true}
                    formkey={Form_Key}
                    values={FormData}
                    formReference={formRef}
                  />
                </div>
              </div>
            </div> */}
          </div>
        </Reactportal>
      </div>
    </>
  );
};

export default MarkDelivery;
